import { render, staticRenderFns } from "./BuildingsDetail.vue?vue&type=template&id=c43526d6&scoped=true&"
import script from "./BuildingsDetail.vue?vue&type=script&lang=ts&"
export * from "./BuildingsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43526d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c43526d6')) {
      api.createRecord('c43526d6', component.options)
    } else {
      api.reload('c43526d6', component.options)
    }
    module.hot.accept("./BuildingsDetail.vue?vue&type=template&id=c43526d6&scoped=true&", function () {
      api.rerender('c43526d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/buildings/BuildingsDetail.vue"
export default component.exports